// Work Hub — one workspace for client work: Clients → Tasks → Planning → Calendar → Team → Reports.
import { LayoutGrid, Building2, CheckSquare, KanbanSquare, CalendarDays, Users, FileBarChart } from "lucide-react";

/** Sub-pages in sidebar order. `page` is the permission key in Access Control. */
export const WORK_HUB_ITEMS = [
  { to: "/work-hub", label: "Overview", icon: LayoutGrid, page: "work_hub", end: true },
  { to: "/work-hub/clients", label: "Clients", icon: Building2, page: "clients", moduleKey: "clients" },
  { to: "/work-hub/tasks", label: "Tasks", icon: CheckSquare, page: "tasks", moduleKey: "tasks" },
  { to: "/work-hub/planner", label: "Work Planner", icon: KanbanSquare, page: "work_planner" },
  { to: "/work-hub/calendar", label: "Calendar", icon: CalendarDays, page: "work_calendar" },
  { to: "/work-hub/team-workload", label: "Team Workload", icon: Users, page: "team_workload" },
  { to: "/work-hub/reports", label: "Reports", icon: FileBarChart, page: "work_reports" },
];

/** Paths that belong to Work Hub (the older /work-planner/* detail pages included). */
export const isWorkHubPath = (path) => path === "/work-hub" || path.startsWith("/work-hub/") || path.startsWith("/work-planner");

/** Permission key for a Work Hub path (longest matching prefix). */
export function workHubPageFor(path) {
  if (path.startsWith("/work-planner")) return "work_planner";
  const hit = WORK_HUB_ITEMS.filter((i) => path === i.to || (i.to !== "/work-hub" && path.startsWith(`${i.to}/`)))
    .sort((a, b) => b.to.length - a.to.length)[0];
  return hit ? hit.page : undefined;
}

/** Items the user may see. Admins see everything. */
export function visibleWorkHubItems(user) {
  if (!user) return [];
  if (["super_admin", "admin"].includes(user.role)) return WORK_HUB_ITEMS;
  const perms = user.effective_permissions || [];
  return WORK_HUB_ITEMS.filter((i) => perms.includes(i.page));
}
